import { render } from "./HeaderCreateView.vue?vue&type=template&id=3b679b54&scoped=true"
import script from "./HeaderCreateView.vue?vue&type=script&lang=js"
export * from "./HeaderCreateView.vue?vue&type=script&lang=js"

import "./HeaderCreateView.vue?vue&type=style&index=0&id=3b679b54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b679b54"]])

export default __exports__